module.exports = __webpack_public_path__ + "static/img/header.396397c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/header.png
// module id = jLGe
// module chunks = 0